var map = {
	"./Direct-Booking/direct-booking.module": [
		"./src/app/Direct-Booking/direct-booking.module.ts",
		"default~Direct-Booking-direct-booking-module~Others-booking-page-booking-page-module",
		"common",
		"Direct-Booking-direct-booking-module"
	],
	"./Home-Page/home-page.module": [
		"./src/app/Home-Page/home-page.module.ts",
		"Home-Page-home-page-module"
	],
	"./Online-Booking/online-booking.module": [
		"./src/app/Online-Booking/online-booking.module.ts",
		"common",
		"Online-Booking-online-booking-module"
	],
	"./Others/booking-page/booking-page.module": [
		"./src/app/Direct-Booking/Others/booking-page/booking-page.module.ts",
		"default~Direct-Booking-direct-booking-module~Others-booking-page-booking-page-module",
		"Others-booking-page-booking-page-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;